let initialState = {
  first_name: '',
  last_name: '',
  password: '',
  confirm_password: '',
  confirm_email_token: ''
};

export default function signForm(state = initialState, action) {
  switch (action.type) {
    case 'RESET_SIGN_FORM':
      return initialState;
    case 'SET_EMAIL_TOKEN':
      return {
        ...state,
        confirm_email_token: action.payload
      };
    default:
      break;
  }
  return state;
}



/** WEBPACK FOOTER **
 ** ./src/reducers/forms/signOwnerForm.js
 **/